import moment from "moment";

export default {
  filters: {
    shortMonthOrdinal(dateString): string {
      return moment(dateString).format("MMM Do, YYYY [at] h:mm a");
    },
    time12(dateString): string {
      return moment(dateString).format("h:mm a");
    },
    shortDate(dateString): string {
      return moment(dateString).format("MMM Do, YYYY");
    },
    longDate(dateString): string {
      return moment(dateString).format("MMMM Do, YYYY");
    },
    slashDate(dateString): string {
      return moment(dateString).format("MM/DD/YY");
    }
  }
};